import { T } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'

interface Props {
  isCommitting: boolean
  isLoading: boolean
  commitTransfer: () => void
  domain: string
}
export const Commit = ({
  isCommitting,
  isLoading,
  commitTransfer,
  domain,
}: Props) => (
  <Button
    loading={isCommitting}
    disabled={isLoading}
    variant="primary"
    onClick={() => {
      commitTransfer()
    }}
  >
    <T
      defaultMessage="Switch to {domain}"
      id="Admin.Domain.SwitchDomain"
      values={{
        domain,
      }}
    />
  </Button>
)
